import { MAKE_API_CALL } from '../types'

const generateApiAction = (
  method,
  path,
  data,
  successHandler,
  errorHandler,
  skipAuthHeader,
  config = {},
) => {
  return {
    type: MAKE_API_CALL,
    payload: {
      method: method,
      path,
      data,
      successHandler,
      errorHandler,
      skipAuthHeader,
      config,
    },
  }
}

export default {
  get: (path, params, successHandler, errorHandler, skipAuthHeader, config) => {
    return {
      type: MAKE_API_CALL,
      payload: {
        method: 'get',
        path,
        params,
        successHandler,
        errorHandler,
        skipAuthHeader,
        config,
      },
    }
  },
  post: (path, data, successHandler, errorHandler, skipAuthHeader, config) => {
    return generateApiAction(
      'post',
      path,
      data,
      successHandler,
      errorHandler,
      skipAuthHeader,
      config,
    )
  },
  put: (path, data, successHandler, errorHandler, skipAuthHeader, config = {}) => {
    return generateApiAction(
      'put',
      path,
      data,
      successHandler,
      errorHandler,
      skipAuthHeader,
      config,
    )
  },
  patch: (path, data, successHandler, errorHandler, skipAuthHeader, config = {}) => {
    return generateApiAction(
      'patch',
      path,
      data,
      successHandler,
      errorHandler,
      skipAuthHeader,
      config,
    )
  },
}



// WEBPACK FOOTER //
// ./src/actions/api/index.js